import { createRouteRef } from '@backstage/frontend-plugin-api';

/** The board page at `/arch-drawio`, which the sidebar entry links to. */
export const rootRouteRef = createRouteRef();
